import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="border-b border-background-200 bg-background-100">
      <div className="w-full px-4 py-12 md:px-8 md:py-16">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">按主题找内容</h2>
            <p className="mt-2 text-sm text-foreground-600">
              三个主题方向覆盖大多数讨论场景，点进去可以看到该分类下的全部整理。
            </p>
          </div>
          <Link
            to="/topics"
            className="inline-flex w-fit items-center gap-1 whitespace-nowrap rounded-md border border-foreground-300 px-4 py-2 text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600 cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line text-base"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/topics?cat=${cat.id}`}
              className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 cursor-pointer"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-primary-100 group-hover:text-primary-700">
                <i className={`${cat.icon} text-xl`}></i>
              </span>
              <div>
                <h3 className="font-heading text-base font-bold text-foreground-950">{cat.name}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}